import React from 'react';
import Dialog from 'Components/Core/Dialog';
import './RezeptView.css';

export default function RezeptView(props) {

	const x = props.x;
	const rezept = props.rezept || {};
	const name = rezept.name || '';
	const kategorieName = rezept.kategoriename || 'Ohne Kategorie';
	const description = rezept.description || '';

	function edit() {
		x.wad[props.id].hide();
		if (typeof props.onEdit !== 'undefined') props.onEdit();
	}

	return (
		<Dialog id={props.id} x={x} title="Rezept" classes="dialog-rezept-view" closeIcon="1">
			<div className="rezept-view">
				<div className="rezept-view-header">
					<span className="rezept-view-title-group">
						<h2 className="rezept-view-title">{name}</h2>
						<i className="bi bi-pencil rezept-view-edit-icon" title="Bearbeiten" onClick={edit}></i>
					</span>
					<span className="rezept-view-kategorie">{kategorieName}</span>
				</div>
				<div
					className="rezept-view-description"
					dangerouslySetInnerHTML={{ __html: x.wau.translatePosting(description) }}
				/>
			</div>
		</Dialog>
	)

};
